import Close from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import type { FormEvent, ReactNode } from 'react';

export interface SettingsCrudDialogProps {
  open: boolean;
  title: string;
  error: string | null;
  saving: boolean;
  onClose: () => void;
  onSubmit: (e: FormEvent) => void;
  children: ReactNode;
}

export default function SettingsCrudDialog({
  open,
  title,
  error,
  saving,
  onClose,
  onSubmit,
  children,
}: SettingsCrudDialogProps) {
  const handleDialogClose = (_event: unknown, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (saving) return;
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      slotProps={{
        paper: {
          elevation: 8,
          sx: { borderRadius: 2 },
        },
      }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label="Хаах"
          onClick={onClose}
          disabled={saving}
          size="small"
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <Box component="form" onSubmit={onSubmit} noValidate>
        <DialogContent dividers>
          <Stack spacing={2.5} sx={{ pt: 0.5 }}>
            {error && (
              <Alert severity="error" role="alert">
                {error}
              </Alert>
            )}
            {children}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          <Button variant="outlined" color="inherit" onClick={onClose} disabled={saving}>
            Цуцлах
          </Button>
          <Button type="submit" variant="contained" color="primary" disabled={saving}>
            {saving ? 'Хадгалж байна...' : 'Хадгалах'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
